import { useLocation } from 'react-router-dom';

const useSearchParam = (param) => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  return params.get(param);
};

const addSearchParam = (param, value) => {
  const search = window.location.search;
  const params = new URLSearchParams(search);

  // Remove param if value is empty
  if (value === null || value === undefined || value === '') {
    params.delete(param);
    return params.toString();
  }

  if (params.has(param)) {
    params.delete(param);
  }
  params.append(param, value);
  return params.toString();
};

const addSearchParams = (params) => {
  const search = window.location.search;
  const urlParams = new URLSearchParams(search);

  // Handle object of params
  Object.entries(params).forEach(([param, value]) => {
    // Skip empty values - check for null, undefined, empty string, or whitespace-only string
    if (value === null || value === undefined || String(value).trim() === '') {
      urlParams.delete(param);
      return;
    }

    if (urlParams.has(param)) {
      urlParams.delete(param);
    }
    urlParams.append(param, value);
  });

  return urlParams.toString();
};

const useParseQueryToParams = (queryString = '') => {
  const params = new URLSearchParams(queryString);
  return Object.fromEntries(params.entries());
};

const objectToQueryString = (obj) => {
  // Filter out null, undefined, and empty string values
  const validParams = Object.entries(obj).filter(([, value]) => value !== null && value !== undefined && String(value).trim() !== '');

  // Convert to query string
  const queryString = validParams.map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`).join('&');

  // Return with leading ? only if there are parameters
  return queryString ? `?${queryString}` : '';
};
export { useSearchParam, addSearchParam, addSearchParams, useParseQueryToParams, objectToQueryString };
